import React, { useEffect } from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import Contact from './pages/Contact';
import ServicePage from './pages/ServicePage';

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const App = () => {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <div className="min-h-screen bg-white flex flex-col font-sans text-slate-900 selection:bg-slate-900 selection:text-white">
          <ScrollToTop />
          <Header />
          <div className="flex-grow">
            <Routes>
              {/* --- DANISH ROUTES (DEFAULT) --- */}
              <Route path="/" element={<Home />} />
              <Route path="/service" element={<ServicePage identifier="service" />} />
              <Route path="/teknisk-radgivning" element={<ServicePage identifier="teknisk-radgivning" />} />
              <Route path="/salg-og-kob" element={<ServicePage identifier="salg-og-kob" />} />
              <Route path="/ecm-certifikat" element={<ServicePage identifier="ecm-certifikat" />} />
              <Route path="/kontakt" element={<Contact />} />

              {/* --- ENGLISH ROUTES --- */}
              <Route path="/en" element={<Home />} />
              <Route path="/en/service" element={<ServicePage identifier="service" />} />
              <Route path="/en/technical-advisory" element={<ServicePage identifier="teknisk-radgivning" />} />
              <Route path="/en/sales-purchase" element={<ServicePage identifier="salg-og-kob" />} />
              <Route path="/en/ecm-certificate" element={<ServicePage identifier="ecm-certifikat" />} />
              <Route path="/en/contact" element={<Contact />} />

              {/* --- GERMAN ROUTES --- */}
              <Route path="/de" element={<Home />} />
              <Route path="/de/service" element={<ServicePage identifier="service" />} />
              <Route path="/de/technische-beratung" element={<ServicePage identifier="teknisk-radgivning" />} />
              <Route path="/de/verkauf-kauf" element={<ServicePage identifier="salg-og-kob" />} />
              <Route path="/de/ecm-zertifikat" element={<ServicePage identifier="ecm-certifikat" />} />
              <Route path="/de/kontakt" element={<Contact />} />

              {/* --- REDIRECTS FOR OLD / MISMATCHED URLS --- */}
              {/* English redirects */}
              <Route path="/en/kontakt" element={<Navigate to="/en/contact" replace />} />
              <Route path="/en/teknisk-radgivning" element={<Navigate to="/en/technical-advisory" replace />} />
              <Route path="/en/salg-og-kob" element={<Navigate to="/en/sales-purchase" replace />} />
              <Route path="/en/ecm-certifikat" element={<Navigate to="/en/ecm-certificate" replace />} />
              
              <Route path="/contact" element={<Navigate to="/en/contact" replace />} />
              <Route path="/technical-advisory" element={<Navigate to="/en/technical-advisory" replace />} />
              <Route path="/sales-purchase" element={<Navigate to="/en/sales-purchase" replace />} />
              <Route path="/ecm-certificate" element={<Navigate to="/en/ecm-certificate" replace />} />

              {/* German redirects */}
              <Route path="/de/teknisk-radgivning" element={<Navigate to="/de/technische-beratung" replace />} />
              <Route path="/de/salg-og-kob" element={<Navigate to="/de/verkauf-kauf" replace />} />
              <Route path="/de/ecm-certifikat" element={<Navigate to="/de/ecm-zertifikat" replace />} />

              {/* Fallback to home */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
          <Footer />
        </div>
      </LanguageProvider>
    </HelmetProvider>
  );
};

export default App;
